import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { Layout } from 'antd'
import React, { FunctionComponent } from 'react'
import NotFound from '../../views/NotFound/NotFound'
import useRouteLog from '../hooks/useRouteLog'
import useWindowError from '../../hooks/logging/useWindowError'
import Notifications from '../../components/Notifications/Notifications'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import LoadingScreen from '../LoadingScreen/LoadingScreen'

const { Content } = Layout

export interface RootRouteContext {
  client: any
  queryClient: any
  authUser: any
  authUserLoading: boolean
  setAuthUser: any
  clearAuthUser: any
}

export const Route = createRootRouteWithContext<RootRouteContext>()({
  notFoundComponent: () => <NotFound />,
  component: () => <Component />,
  pendingComponent: () => <LoadingScreen />
})

const Component: FunctionComponent<any> = () => {
  useRouteLog('__root.tsx')
  useWindowError()
  return (
    <Layout style={{ height: '100vh', width: '100vw' }}>
      <Notifications />
      <Content style={{ overflow: 'auto' }}>
        <Outlet />
      </Content>
      <TanStackRouterDevtools position={'bottom-right'} />
    </Layout>
  )
}
